module.exports = __webpack_public_path__ + "static/bannerImg-33b446b6e9fb6a13579d6ed3e45901ad.png";